export const ACTION = {
    SEE_ALL_CONTENT: 'SEE-ALL-CONTENT',
    CLEAR_CONTENT: 'CLEAR-CONTENT',
    SEE_ALL_GENRA: 'SEE-ALL-GENRA',
};

export const SEE_ALL_LIMIT = 100;